const OFFER_SCHEDULE_URL = '/schedule/offer';
const OFFER_GEO_SCHEDULE_URL = '/schedule/offer-geo';

export function offerSchedule(id: string) {
  return `${OFFER_SCHEDULE_URL}/${id}`;
}

export function offerGeoSchedule(id: string) {
  return `${OFFER_GEO_SCHEDULE_URL}/${id}`;
}
